<div
  [class.err-box]="type === 'warn'"
  [class.warn-box]="type === 'primary'"
  class="p-2 m-v-2"
  fxLayoutAlign="start center"
>
  <mat-icon [color]="type" class="m-r-1">info</mat-icon>
  <ng-content />
</div>
